// Automatically generetated by @tempo/theme do not alter.
export const tokens = {
    breakpoints: {
        '2xl': '1800px',
        lg: '1200px',
        md: '1024px',
        sm: '724px',
        xl: '1535px'
    },
    fonts: {
        body: 'Inter, Arial, sans-serif',
        heading: '"Deezer Product", Tahoma, Arial, sans-serif',
        mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
    },
    fontSizes: {
        xs: '0.75rem',
        sm: '0.875rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem',
        '7xl': '4.5rem',
        '8xl': '6rem',
        '9xl': '8rem'
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
    },
    lineHeights: {
        '3': '.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '7': '1.75rem',
        '8': '2rem',
        '9': '2.25rem',
        '10': '2.5rem',
        normal: 'normal',
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: '2'
    },
    colors: {
        acid: {
            '50': '#ffffeb',
            '60': '#feffb7',
            '70': '#fcff60',
            '80': '#ecef5a',
            '90': '#dbde54',
            '100': '#c3c64a',
            '110': '#a29a39',
            '120': '#7e772c',
            '130': '#5c5620',
            '140': '#403c1a',
            '150': '#25220c'
        },
        algae: {
            '50': '#fbfefc',
            '60': '#f3fdf5',
            '70': '#eafbed',
            '80': '#c1f4ca',
            '90': '#8eec9f',
            '100': '#6bd57e',
            '110': '#55a964',
            '120': '#41824d',
            '130': '#305f38',
            '140': '#214227',
            '150': '#132616'
        },
        blue: {
            '50': '#fdfdff',
            '60': '#fafaff',
            '70': '#f6f7ff',
            '80': '#e4e6ff',
            '90': '#d0d5fe',
            '100': '#b4bbfe',
            '110': '#828efd',
            '120': '#5263fc',
            '130': '#2d3ed9',
            '140': '#202c99',
            '150': '#121959'
        },
        carrot: {
            '50': '#fffaef',
            '60': '#fef2d6',
            '70': '#fee2ae',
            '80': '#fece85',
            '90': '#feba67',
            '100': '#fe9935',
            '110': '#da7726',
            '120': '#b6581a',
            '130': '#933e10',
            '140': '#792b0a',
            '150': '#792b0a'
        },
        flame: {
            '50': '#fffefa',
            '60': '#fffaee',
            '70': '#fff7e1',
            '80': '#ffe6a6',
            '90': '#ffd25f',
            '100': '#e6ba4a',
            '110': '#b6933b',
            '120': '#8c712d',
            '130': '#665221',
            '140': '#473a17',
            '150': '#28210d'
        },
        green: {
            '50': '#e8f5e9',
            '60': '#c8e6c9',
            '70': '#a5d6a7',
            '80': '#4dc977',
            '90': '#66bb6a',
            '100': '#00b23d',
            '110': '#43a047',
            '120': '#388e3c',
            '130': '#2e7d32',
            '140': '#1b5e20',
            '150': '#1b5e20'
        },
        indigo: {
            '50': '#fefdff',
            '60': '#fbfaff',
            '70': '#f7f6ff',
            '80': '#e9e5ff',
            '90': '#d9d2ff',
            '100': '#c3b6ff',
            '110': '#9b86ff',
            '120': '#7357ff',
            '130': '#523ac9',
            '140': '#3a298e',
            '150': '#211752'
        },
        jellyfish: {
            '50': '#fbfefe',
            '60': '#f1fdfb',
            '70': '#e7fbf8',
            '80': '#b5f4eb',
            '90': '#76ead9',
            '100': '#2ed6bd',
            '110': '#24aa96',
            '120': '#1c8374',
            '130': '#145f54',
            '140': '#0e433b',
            '150': '#082622'
        },
        lava: {
            '50': '#fffdfd',
            '60': '#fff9f9',
            '70': '#fff5f5',
            '80': '#ffe1e1',
            '90': '#ffcaca',
            '100': '#ffa9a9',
            '110': '#ff6464',
            '120': '#da3434',
            '130': '#a02626',
            '140': '#711b1b',
            '150': '#421010'
        },
        magenta: {
            '50': '#fffdff',
            '60': '#fff9ff',
            '70': '#fef4ff',
            '80': '#fddeff',
            '90': '#fbc6ff',
            '100': '#f9a0ff',
            '110': '#de68e7',
            '120': '#ab50b2',
            '130': '#7d3a81',
            '140': '#58295b',
            '150': '#321734'
        },
        neutral: {
            '10': '#fdfcfe',
            '20': '#f5f2f8',
            '30': '#ebe7ee',
            '40': '#e1dde4',
            '50': '#d1cfd3',
            '60': '#c2c0c4',
            '70': '#b4b1b6',
            '80': '#a9a6aa',
            '90': '#9a979c',
            '100': '#8c898e',
            '110': '#7d7b80',
            '120': '#6f6d71',
            '130': '#615e63',
            '140': '#555257',
            '150': '#464549',
            '160': '#3a393d',
            '170': '#29282d',
            '180': '#1b191f',
            '190': '#0f0d13',
            '200': '#000000',
            '00': '#ffffff'
        },
        orange: {
            '50': '#fffdfd',
            '60': '#fff9f8',
            '70': '#fff5f2',
            '80': '#ffe2d9',
            '90': '#ffccbd',
            '100': '#ffab93',
            '110': '#ff673d',
            '120': '#c54f2f',
            '130': '#8f3a22',
            '140': '#652918',
            '150': '#3a170e'
        },
        pink: {
            '50': '#fffdfe',
            '60': '#fef9fc',
            '70': '#fef5f9',
            '80': '#fbe1ee',
            '90': '#f8cbe1',
            '100': '#f3aace',
            '110': '#eb6cab',
            '120': '#ca3e84',
            '130': '#932e60',
            '140': '#682044',
            '150': '#3c1327'
        },
        purple: {
            '50': '#f6ebff',
            '60': '#e2c1ff',
            '70': '#d4a3ff',
            '80': '#c17aff',
            '90': '#b560ff',
            '100': '#a238ff',
            '110': '#9333e8',
            '120': '#7328b5',
            '130': '#591f8c',
            '140': '#44186b',
            '150': '#32124e'
        },
        red: {
            '50': '#ffebee',
            '60': '#ffcdd2',
            '70': '#ef9a9a',
            '80': '#e57373',
            '90': '#ef5350',
            '100': '#f44336',
            '110': '#e53935',
            '120': '#d32f2f',
            '130': '#c62828',
            '140': '#b71c1c',
            '150': '#b71c1c'
        },
        teal: {
            '50': '#f9fffe',
            '60': '#ecfefd',
            '70': '#defdfb',
            '80': '#96f9f3',
            '90': '#8be7e1',
            '100': '#7ccec9',
            '110': '#54a6b5',
            '120': '#33808f',
            '130': '#125e6e',
            '140': '#03424f',
            '150': '#0d262b'
        }
    },
    radii: {
        '2xs': '0.125rem',
        xs: '0.25rem',
        s: '0.5rem',
        m: '0.75rem',
        l: '1rem',
        rounded: '16rem'
    },
    semanticTokens: {
        colors: {
            'background.accent.onContent.default': '#00000066',
            'background.accent.onContent.disabled': '#00000029',
            'background.accent.onContent.hovered': '#0000008f',
            'background.accent.onContent.pressed': '#000000a3',
            'background.accent.onDark.default': 'neutral.10',
            'background.accent.onDark.disabled': 'neutral.30',
            'background.accent.onDark.hovered': 'neutral.20',
            'background.accent.onDark.pressed': 'neutral.30',
            'background.accent.onDark.selected': 'purple.50',
            'background.accent.onLight.default': 'neutral.190',
            'background.accent.onLight.disabled': 'neutral.170',
            'background.accent.onLight.hovered': 'neutral.180',
            'background.accent.onLight.pressed': 'neutral.170',
            'background.accent.onLight.selected': 'purple.150',
            'background.accent.primary.default': 'purple.100',
            'background.accent.primary.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.accent.primary.hovered': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'background.accent.primary.pressed': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'background.brand.acid.dark': 'acid.110',
            'background.brand.acid.deep': 'acid.130',
            'background.brand.acid.default': 'acid.70',
            'background.brand.acid.light': 'acid.60',
            'background.brand.acid.pale': 'acid.50',
            'background.brand.algae.dark': 'algae.110',
            'background.brand.algae.deep': 'algae.130',
            'background.brand.algae.default': 'algae.100',
            'background.brand.algae.light': 'algae.90',
            'background.brand.algae.pale': 'algae.80',
            'background.brand.black.default': 'neutral.180',
            'background.brand.blue.dark': 'blue.130',
            'background.brand.blue.deep': 'blue.140',
            'background.brand.blue.default': 'blue.120',
            'background.brand.blue.light': 'blue.100',
            'background.brand.blue.pale': 'blue.90',
            'background.brand.flame.dark': 'flame.110',
            'background.brand.flame.deep': 'flame.120',
            'background.brand.flame.default': 'flame.90',
            'background.brand.flame.light': 'flame.80',
            'background.brand.flame.pale': 'flame.70',
            'background.brand.indigo.dark': 'indigo.130',
            'background.brand.indigo.deep': 'indigo.140',
            'background.brand.indigo.default': 'indigo.120',
            'background.brand.indigo.light': 'indigo.100',
            'background.brand.indigo.pale': 'indigo.90',
            'background.brand.jellyfish.dark': 'jellyfish.110',
            'background.brand.jellyfish.deep': 'jellyfish.130',
            'background.brand.jellyfish.default': 'jellyfish.100',
            'background.brand.jellyfish.light': 'jellyfish.90',
            'background.brand.jellyfish.pale': 'jellyfish.80',
            'background.brand.lava.dark': 'lava.130',
            'background.brand.lava.deep': 'lava.140',
            'background.brand.lava.default': 'lava.120',
            'background.brand.lava.light': 'lava.100',
            'background.brand.lava.pale': 'lava.90',
            'background.brand.magenta.dark': 'magenta.120',
            'background.brand.magenta.deep': 'magenta.130',
            'background.brand.magenta.default': 'magenta.110',
            'background.brand.magenta.light': 'magenta.90',
            'background.brand.magenta.pale': 'magenta.80',
            'background.brand.orange.dark': 'orange.120',
            'background.brand.orange.deep': 'orange.130',
            'background.brand.orange.default': 'orange.110',
            'background.brand.orange.light': 'orange.90',
            'background.brand.orange.pale': 'orange.80',
            'background.brand.pink.dark': 'pink.130',
            'background.brand.pink.deep': 'pink.140',
            'background.brand.pink.default': 'pink.120',
            'background.brand.pink.light': 'pink.100',
            'background.brand.pink.pale': 'pink.90',
            'background.brand.purple.dark': '#7629ba',
            'background.brand.purple.deep': '#531d83',
            'background.brand.purple.default': 'purple.100',
            'background.brand.purple.light': '#d9aeff',
            'background.brand.purple.pale': '#e8cdff',
            'background.brand.teal.dark': 'teal.120',
            'background.brand.teal.deep': 'teal.130',
            'background.brand.teal.default': 'teal.100',
            'background.brand.teal.light': 'teal.80',
            'background.brand.teal.pale': 'teal.70',
            'background.brand.white.default': 'neutral.20',
            'background.feedback.error.default': 'red.100',
            'background.feedback.error.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'background.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'background.feedback.success.default': 'green.100',
            'background.feedback.success.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'background.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'background.feedback.warning.default': 'carrot.100',
            'background.feedback.warning.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'background.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'background.neutral.inverse.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'background.neutral.inverse.disabled': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'background.neutral.inverse.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'background.neutral.inverse.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'background.neutral.inverse.selected': {
                default: 'purple.150',
                _dark: 'purple.50'
            },
            'background.neutral.primary.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'background.neutral.primary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.primary.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'background.neutral.primary.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.primary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'background.neutral.secondary.default': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'background.neutral.secondary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.secondary.hovered': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.secondary.pressed': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.secondary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'background.neutral.tertiary.default': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.tertiary.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.tertiary.hovered': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.tertiary.pressed': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'background.neutral.tertiary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'border.accent.onContent.default': 'neutral.10',
            'border.accent.onContent.disabled': 'neutral.100',
            'border.accent.onContent.focused': 'purple.100',
            'border.accent.onContent.hovered': 'neutral.20',
            'border.accent.onContent.pressed': 'neutral.30',
            'border.accent.primary.default': 'purple.100',
            'border.accent.primary.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.accent.primary.focused': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'border.accent.primary.hovered': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'border.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'border.feedback.error.default': 'red.100',
            'border.feedback.error.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.error.focused': 'purple.100',
            'border.feedback.error.hovered': 'red.100',
            'border.feedback.error.pressed': 'red.100',
            'border.feedback.success.default': 'green.100',
            'border.feedback.success.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.success.focused': 'purple.100',
            'border.feedback.success.hovered': 'green.100',
            'border.feedback.success.pressed': 'green.100',
            'border.feedback.warning.default': 'carrot.100',
            'border.feedback.warning.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.warning.focused': 'purple.100',
            'border.feedback.warning.hovered': 'carrot.100',
            'border.feedback.warning.pressed': 'carrot.100',
            'border.neutral.primary.default': {
                default: 'neutral.60',
                _dark: 'neutral.140'
            },
            'border.neutral.primary.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.neutral.primary.focused': 'purple.100',
            'border.neutral.primary.hovered': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'border.neutral.primary.pressed': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'comp.coverDailyMix.color.background': 'red.50',
            'comp.coverDiscovery.color.background': 'red.60',
            'comp.coverFamilyMix.color.background': 'orange.90',
            'comp.coverMonthly.color.background': 'purple.60',
            'comp.coverNewRelease.color.background': 'purple.70',
            'divider.neutral.primary.default': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'divider.neutral.primary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'divider.neutral.primary.hovered': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'divider.neutral.primary.pressed': {
                default: 'neutral.60',
                _dark: 'neutral.140'
            },
            'icon.accent.onDark.default': 'neutral.10',
            'icon.accent.onDark.disabled': 'neutral.120',
            'icon.accent.onDark.hovered': 'neutral.20',
            'icon.accent.onDark.pressed': 'neutral.30',
            'icon.accent.onDark.selected': 'purple.90',
            'icon.accent.onLight.default': 'neutral.190',
            'icon.accent.onLight.disabled': 'neutral.80',
            'icon.accent.onLight.hovered': 'neutral.180',
            'icon.accent.onLight.pressed': 'neutral.170',
            'icon.accent.onLight.selected': 'purple.110',
            'icon.accent.primary.default': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'icon.accent.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.accent.primary.hovered': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'icon.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'icon.feedback.error.default': 'red.100',
            'icon.feedback.error.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'icon.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'icon.feedback.success.default': 'green.100',
            'icon.feedback.success.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'icon.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'icon.feedback.warning.default': 'carrot.100',
            'icon.feedback.warning.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'icon.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'icon.neutral.inverse.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'icon.neutral.inverse.disabled': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'icon.neutral.inverse.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'icon.neutral.inverse.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'icon.neutral.inverse.selected': {
                default: 'purple.90',
                _dark: 'purple.110'
            },
            'icon.neutral.primary.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'icon.neutral.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.neutral.primary.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'icon.neutral.primary.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'icon.neutral.primary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'icon.neutral.secondary.default': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'icon.neutral.secondary.disabled': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'icon.neutral.secondary.hovered': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            },
            'icon.neutral.secondary.pressed': {
                default: 'neutral.140',
                _dark: 'neutral.60'
            },
            'icon.neutral.secondary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'icon.neutral.tertiary.default': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.neutral.tertiary.disabled': {
                default: 'neutral.60',
                _dark: 'neutral.140'
            },
            'icon.neutral.tertiary.hovered': {
                default: 'neutral.90',
                _dark: 'neutral.110'
            },
            'icon.neutral.tertiary.pressed': 'neutral.100',
            'icon.neutral.tertiary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'logo.symbol.accent': 'purple.100',
            'logo.symbol.onDark': 'neutral.00',
            'logo.symbol.onLight': 'neutral.200',
            'logo.wordmark.primary': {
                default: 'neutral.200',
                _dark: 'neutral.00'
            },
            'logo.wordmark.onDark': 'neutral.00',
            'logo.wordmark.onLight': 'neutral.200',
            'text.accent.onColor.default': {
                default: '#0000007a',
                _dark: '#ffffff7a'
            },
            'text.accent.onColor.disabled': {
                default: '#00000029',
                _dark: '#ffffff29'
            },
            'text.accent.onColor.hovered': {
                default: '#000000a3',
                _dark: '#ffffffa3'
            },
            'text.accent.onColor.pressed': {
                default: '#000000b8',
                _dark: '#ffffffb8'
            },
            'text.accent.onDark.default': 'neutral.10',
            'text.accent.onDark.disabled': 'neutral.120',
            'text.accent.onDark.hovered': 'neutral.20',
            'text.accent.onDark.pressed': 'neutral.30',
            'text.accent.onDark.selected': 'purple.90',
            'text.accent.onLight.default': 'neutral.190',
            'text.accent.onLight.disabled': 'neutral.80',
            'text.accent.onLight.hovered': 'neutral.180',
            'text.accent.onLight.pressed': 'neutral.170',
            'text.accent.onLight.selected': 'purple.110',
            'text.accent.primary.default': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'text.accent.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.accent.primary.hovered': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'text.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'text.feedback.error.default': 'red.100',
            'text.feedback.error.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'text.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'text.feedback.success.default': 'green.100',
            'text.feedback.success.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'text.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'text.feedback.warning.default': 'carrot.100',
            'text.feedback.warning.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'text.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'text.neutral.inverse.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'text.neutral.inverse.disabled': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'text.neutral.inverse.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'text.neutral.inverse.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'text.neutral.inverse.selected': {
                default: 'purple.90',
                _dark: 'purple.110'
            },
            'text.neutral.primary.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'text.neutral.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.neutral.primary.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'text.neutral.primary.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'text.neutral.primary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'text.neutral.secondary.default': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'text.neutral.secondary.disabled': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'text.neutral.secondary.hovered': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            },
            'text.neutral.secondary.pressed': {
                default: 'neutral.140',
                _dark: 'neutral.60'
            },
            'text.neutral.secondary.selected': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            }
        },
        sizes: {
            'size.xs': 'x1',
            'size.s': 'x1_5',
            'size.m': 'x2',
            'size.l': 'x2_5',
            'size.xl': 'x3',
            'size.2xl': 'x4',
            'size.3xl': 'x8',
            'size.4xl': 'x16',
            'spacing.2xs': 'x0_125',
            'spacing.xs': 'x0_250',
            'spacing.s': 'x0_5',
            'spacing.m': 'x0_75',
            'spacing.l': 'x1',
            'spacing.xl': 'x1_5',
            'spacing.2xl': 'x2',
            'spacing.3xl': 'x3',
            'spacing.4xl': 'x4',
            'icon.xs': '0.75rem',
            'icon.s': '1rem',
            'icon.m': '1.5rem',
            'icon.l': '2rem'
        },
        space: {
            'size.xs': 'x1',
            'size.s': 'x1_5',
            'size.m': 'x2',
            'size.l': 'x2_5',
            'size.xl': 'x3',
            'size.2xl': 'x4',
            'size.3xl': 'x8',
            'size.4xl': 'x16',
            'spacing.2xs': 'x0_125',
            'spacing.xs': 'x0_250',
            'spacing.s': 'x0_5',
            'spacing.m': 'x0_75',
            'spacing.l': 'x1',
            'spacing.xl': 'x1_5',
            'spacing.2xl': 'x2',
            'spacing.3xl': 'x3',
            'spacing.4xl': 'x4',
            'icon.xs': '0.75rem',
            'icon.s': '1rem',
            'icon.m': '1.5rem',
            'icon.l': '2rem'
        },
        fontSizes: {
            'display.l': '80px',
            'display.m': '64px',
            'display.s': '48px',
            'display.2xs': '24px',
            'heading.xl': '40px',
            'heading.l': '32px',
            'heading.m': '20px',
            'heading.s': '18px',
            'heading.xs': '16px',
            'body.2xl': '32px',
            'body.xl': '16px',
            'body.l': '16px',
            'body.m': '14px',
            'body.s': '14px',
            'body.xs': '12px',
            'body.2xs': '12px'
        },
        fontWeights: {
            'display.l': 'bold',
            'display.m': 'bold',
            'display.s': 'bold',
            'display.2xs': 'bold',
            'heading.xl': 'bold',
            'heading.l': 'bold',
            'heading.m': 'bold',
            'heading.s': 'bold',
            'heading.xs': 'medium',
            'body.2xl': 'heavy',
            'body.xl': 'bold',
            'body.l': 'regular',
            'body.m': 'semibold',
            'body.s': 'regular',
            'body.xs': 'semibold',
            'body.2xs': 'regular'
        },
        lineHeights: {
            'display.l': '80px',
            'display.m': '64px',
            'display.s': '48px',
            'display.2xs': '24px',
            'heading.xl': '40px',
            'heading.l': '32px',
            'heading.m': '24px',
            'heading.s': '24px',
            'heading.xs': '20px',
            'body.2xl': '40px',
            'body.xl': '24px',
            'body.l': '24px',
            'body.m': '20px',
            'body.s': '20px',
            'body.xs': '16px',
            'body.2xs': '16px'
        },
        fonts: {
            'display.l': 'heading',
            'display.m': 'heading',
            'display.s': 'heading',
            'display.2xs': 'heading',
            'heading.xl': 'heading',
            'heading.l': 'heading',
            'heading.m': 'body',
            'heading.s': 'body',
            'heading.xs': 'body',
            'body.2xl': 'body',
            'body.xl': 'body',
            'body.l': 'body',
            'body.m': 'body',
            'body.s': 'body',
            'body.xs': 'body',
            'body.2xs': 'body'
        }
    },
    scales: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    },
    sizes: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    },
    space: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    }
};

//# sourceMappingURL=chakra.js.map